import { render, staticRenderFns } from "./GetDesktopImg.vue?vue&type=template&id=52e88106&"
import script from "./GetDesktopImg.vue?vue&type=script&lang=js&"
export * from "./GetDesktopImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52e88106')) {
      api.createRecord('52e88106', component.options)
    } else {
      api.reload('52e88106', component.options)
    }
    module.hot.accept("./GetDesktopImg.vue?vue&type=template&id=52e88106&", function () {
      api.rerender('52e88106', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GetDesktopImg.vue"
export default component.exports